import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-verify-mpin',
  templateUrl: './verify-mpin.component.html',
  styleUrl: './verify-mpin.component.scss'
})
export class VerifyMpinComponent {

  displayResendCode: boolean = false;
  interval: any = null;
  mpin: any;
  modalData: any;
  errorMsgs: any;
  userDetails: any;


  constructor(
    public dialogRef: MatDialogRef<VerifyMpinComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private translate: TranslateService
  ) {
    this.modalData = data;
    translate.get(['toasterStatus']).subscribe(data => {
      this.errorMsgs = data;
    })
  }

  ngOnInit() {
  }

  onOtpChange(mpin: any) {
    this.mpin = mpin;
  }

  verifyMpin() {
     let body = {
          "loginType": 1,
          "userName": this.modalData.icNumber,
          "password": this.mpin,
          "cipher": "",
          "appLoginPin": "",
          "noSharedPreference": true
        }
        this.loginService.loginUser(body).subscribe((res: any) => {
          if (res && res.status && res.status.isSuccess) {
            this.userDetails = res.content;
            this.dialogRef.close({ event: 'mpinVerified', userDetails: this.userDetails, mpin: this.mpin});
          }
          else {
            this.toastrService.error(res.status.statusMessage, this.errorMsgs['toasterStatus'].error)
          }
        })
  }

  cancelClick(event: any) {
    this.dialogRef.close();
    event.stopPropagation();
  }

  forgetPinClick(){
    this.dialogRef.close({event:'forgot'});
  }

}
